import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import moment from 'moment'
import { Label, Menu, Button, Segment, Icon, Loader, Message, Pagination } from 'semantic-ui-react';
import _ from 'lodash';
import printJS from 'print-js';
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import { toIDR } from '../../../../../_utils/tocurrency';

export default class RegisterSTS extends Component {
    constructor(props){
        super(props);
        this.state = {
            data: [],
            requests:true,

            focused: null,
            startDate: null,
            endDate: null,
            focusedInput: null,
            opds:[],
            opd_kode:null,
            opd_name:null,

            activePage:1,
            totalPages:0,

            total:[],
            status:[],
            jumlah:0,
            semua:true,
            semua_data:[],

            rowSpan:[],
            semuaSTS:[],

            dataAll:[],
            urutan:[],
            pageActive: 1,

        }

        this.onFilter = this.onFilter.bind(this);      
        this.onRefresh = this.onRefresh.bind(this);
    }

    handlePaginationChange = (e, { activePage }) => {
        if (this.state.pageActive === activePage){
            return false;
        }
        this.setState({ activePage, pageActive: activePage, requests: true })
        let url = null;
        if(this.state.q!==""){
            url = `${BaseURLDev}/sts?page=${activePage}&q=${this.state.q}`
        }else{
            url = `${BaseURLDev}/sts?page=${activePage}`         
        }
        fetch(url,{headers})
        .then(response => {
            if (!response.ok) { 
                  return Promise.reject(response.statusText);
              }
            return response.json();
        })
        .then(resJSON => {
            var semua_data=[];  var total1=[]; var status=[];
            var semuaBP=[]; var semuaSTS=[]; var count=0; var rowSpan=[];
            for(var i=0;i<resJSON.data.length;i++){
                var tam1=''; var total2=0;
                rowSpan[i]=resJSON.data[i].bp.length;
                for(var j=0; j<resJSON.data[i].bp.length;j++){
                    var stat="";
                    semuaSTS[count]=resJSON.data[i].no_sts;
                    semuaBP[count]=resJSON.data[i].bp[j];
                    for(var k=0; k<resJSON.data[i].bp[j].rincian.length; k++){
                        tam1=tam1+' {'+resJSON.data[i].bp[j].rincian[k].kd_rek_1+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_2+'.'+
                        resJSON.data[i].bp[j].rincian[k].kd_rek_3+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_4+'.'+
                        resJSON.data[i].bp[j].rincian[k].kd_rek_5+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_6+' = '+resJSON.data[i].bp[j].rincian[k].uraian_rinc+" : "+toIDR(resJSON.data[i].bp[j].rincian[k].nilai)+'}, ';
                        total2=total2+resJSON.data[i].bp[j].rincian[k].nilai;
                    }
                    if(resJSON.data[i].bp[j].is_active===true && resJSON.data[i].bp[j].is_verified===false){
                        stat="BP Non STS";
                    } else if(resJSON.data[i].bp[j].is_active===false && resJSON.data[i].bp[j].is_verified===false){
                        stat="BP STS";
                    } else if(resJSON.data[i].bp[j].is_active===false && resJSON.data[i].bp[j].is_verified===true){
                        stat="BP Terealisasi";
                    }
                    status[count]=stat;
                    count=count+1;
                }
                total1[i]=total2;
                semua_data[i]=tam1;
            }

            var urutan=[]; var tambah=0; var tambah1=0;
            for(var i=0; i<semuaBP.length; i++){
                if(i>=1){
                    if(semuaSTS[i]!==semuaSTS[i-1]){
                        tambah=tambah+1;
                    }
                } else { urutan[i]=tambah; }
                if(tambah1!==tambah){
                    urutan[i]=tambah;
                    tambah1=tambah;
                }
               
            }

            this.setState({
                data: semuaBP,
                total: total1,
                urutan: urutan,
                status: status,
                semua_data: semua_data,
                semuaSTS: semuaSTS,
                rowSpan: rowSpan,
                requests: false,
                totalPages: 4,
            })
        });
    }

    onRefresh(){
        this.setState({
            startDate:null,
            endDate:null,
            requests:true
        })

        fetch(`${BaseURLDev}/sts?start=${null}&end=${null}`, { headers })
        .then(response => {
            if(!response.ok){
                window.alert("Load data gagal")            
                this.setState({data:[],requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => {
            var semua_data=[];  var total1=[]; var status=[];
            var semuaBP=[]; var semuaSTS=[]; var count=0; var rowSpan=[];
            for(var i=0;i<resJSON.data.length;i++){
                var tam1=''; var total2=0;
                rowSpan[i]=resJSON.data[i].bp.length;
                for(var j=0; j<resJSON.data[i].bp.length;j++){
                    var stat="";
                    semuaSTS[count]=resJSON.data[i].no_sts;
                    semuaBP[count]=resJSON.data[i].bp[j];
                    for(var k=0; k<resJSON.data[i].bp[j].rincian.length; k++){
                        tam1=tam1+' {'+resJSON.data[i].bp[j].rincian[k].kd_rek_1+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_2+'.'+
                        resJSON.data[i].bp[j].rincian[k].kd_rek_3+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_4+'.'+
                        resJSON.data[i].bp[j].rincian[k].kd_rek_5+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_6+' = '+resJSON.data[i].bp[j].rincian[k].uraian_rinc+" : "+toIDR(resJSON.data[i].bp[j].rincian[k].nilai)+'}, ';
                        total2=total2+resJSON.data[i].bp[j].rincian[k].nilai;
                    }
                    if(resJSON.data[i].bp[j].is_active===true && resJSON.data[i].bp[j].is_verified===false){
                        stat="BP Non STS";
                    } else if(resJSON.data[i].bp[j].is_active===false && resJSON.data[i].bp[j].is_verified===false){
                        stat="BP STS";
                    } else if(resJSON.data[i].bp[j].is_active===false && resJSON.data[i].bp[j].is_verified===true){
                        stat="BP Terealisasi";
                    }
                    status[count]=stat;
                    count=count+1;
                }
                total1[i]=total2;
                semua_data[i]=tam1;
            }

            var urutan=[]; var tambah=0; var tambah1=0;
            for(var i=0; i<semuaBP.length; i++){
                if(i>=1){
                    if(semuaSTS[i]!==semuaSTS[i-1]){
                        tambah=tambah+1;
                    }
                } else { urutan[i]=tambah; }
                if(tambah1!==tambah){
                    urutan[i]=tambah;
                    tambah1=tambah;
                }
               
            }
            
            this.setState({
                data: semuaBP,
                total: total1,
                urutan: urutan,
                status: status,
                semua_data: semua_data,
                semuaSTS: semuaSTS,
                rowSpan: rowSpan,
                requests: false,
                totalPages: 4,
            })
        })
        .catch(e => {
            this.setState({
                requests: false,
            })
            window.alert("Server gangguan")
        })
    }

    onFilter(){
        const { startDate, endDate } = this.state
        const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
        const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD')

        this.setState({requests: true, q: ""})
        fetch(`${BaseURLDev}/sts?start=${start_date}&end=${end_date}`, { headers })
        .then(response => {
            if(!response.ok){
                window.alert("Load data gagal")            
                this.setState({data: [], requests: false});
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => {

            var semua_data=[];  var total1=[]; var status=[];
            var semuaBP=[]; var semuaSTS=[]; var count=0; var rowSpan=[];
            for(var i=0;i<resJSON.data.length;i++){
                var tam1=''; var total2=0;
                rowSpan[i]=resJSON.data[i].bp.length;
                for(var j=0; j<resJSON.data[i].bp.length;j++){
                    var stat="";
                    semuaSTS[count]=resJSON.data[i].no_sts;
                    semuaBP[count]=resJSON.data[i].bp[j];
                    for(var k=0; k<resJSON.data[i].bp[j].rincian.length; k++){
                        tam1=tam1+' {'+resJSON.data[i].bp[j].rincian[k].kd_rek_1+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_2+'.'+
                        resJSON.data[i].bp[j].rincian[k].kd_rek_3+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_4+'.'+
                        resJSON.data[i].bp[j].rincian[k].kd_rek_5+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_6+' = '+resJSON.data[i].bp[j].rincian[k].uraian_rinc+" : "+toIDR(resJSON.data[i].bp[j].rincian[k].nilai)+'}, ';
                        total2=total2+resJSON.data[i].bp[j].rincian[k].nilai;
                    }
                    if(resJSON.data[i].bp[j].is_active===true && resJSON.data[i].bp[j].is_verified===false){
                        stat="BP Non STS";
                    } else if(resJSON.data[i].bp[j].is_active===false && resJSON.data[i].bp[j].is_verified===false){
                        stat="BP STS";
                    } else if(resJSON.data[i].bp[j].is_active===false && resJSON.data[i].bp[j].is_verified===true){
                        stat="BP Terealisasi";
                    }
                    status[count]=stat;
                    count=count+1;
                }
                total1[i]=total2;
                semua_data[i]=tam1;
            }

            var urutan=[]; var tambah=0; var tambah1=0;
            for(var i=0; i<semuaBP.length; i++){
                if(i>=1){
                    if(semuaSTS[i]!==semuaSTS[i-1]){
                        tambah=tambah+1;
                    }
                } else { urutan[i]=tambah; }
                if(tambah1!==tambah){
                    urutan[i]=tambah;
                    tambah1=tambah;
                }
               
            }

            this.setState({
                data: semuaBP,
                total: total1,
                urutan: urutan,
                status: status,
                semua_data: semua_data,
                semuaSTS: semuaSTS,
                rowSpan: rowSpan,
                requests: false,
                totalPages: 4,
            })
        })
    }

    onOpenDetail = (e, { index }) => {
        const { data } = this.state
        this.setState({
            is_detail:true,
            data_detail:data[index],
        });
    }

    onCloseDetail = () => {
        this.setState({
            is_detail:false,
            data_detail:null
        });
    }

    onCloseExport = () => this.setState({is_export:false})
    onOpenExport = () => this.setState({is_export:true})

    handleSort = clickedColumn => () => {
        const { column, data, direction } = this.state

        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                data: _.sortBy(data, [clickedColumn]),
                direction: 'ascending',
            })

            return
        }

        this.setState({
            data: data.reverse(),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        })
    }

    componentDidMount(){
        fetch(`${BaseURLDev}/sts`, { headers })
        .then(response => {
            if(!response.ok){
                window.alert("Load data gagal")            
                this.setState({data:[],requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => {

            var semua_data=[];  var total1=[]; var status=[];
            var semuaBP=[]; var semuaSTS=[]; var count=0; var rowSpan=[];
            for(var i=0;i<resJSON.data.length;i++){
                var tam1=''; var total2=0;
                rowSpan[i]=resJSON.data[i].bp.length;
                for(var j=0; j<resJSON.data[i].bp.length;j++){
                    var stat="";
                    semuaSTS[count]=resJSON.data[i].no_sts;
                    semuaBP[count]=resJSON.data[i].bp[j];
                    for(var k=0; k<resJSON.data[i].bp[j].rincian.length; k++){
                        tam1=tam1+' {'+resJSON.data[i].bp[j].rincian[k].kd_rek_1+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_2+'.'+
                        resJSON.data[i].bp[j].rincian[k].kd_rek_3+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_4+'.'+
                        resJSON.data[i].bp[j].rincian[k].kd_rek_5+'.'+resJSON.data[i].bp[j].rincian[k].kd_rek_6+' = '+resJSON.data[i].bp[j].rincian[k].uraian_rinc+" : "+toIDR(resJSON.data[i].bp[j].rincian[k].nilai)+'}, ';
                        total2=total2+resJSON.data[i].bp[j].rincian[k].nilai;
                    }
                    if(resJSON.data[i].bp[j].is_active===true && resJSON.data[i].bp[j].is_verified===false){
                        stat="BP Non STS";
                    } else if(resJSON.data[i].bp[j].is_active===false && resJSON.data[i].bp[j].is_verified===false){
                        stat="BP STS";
                    } else if(resJSON.data[i].bp[j].is_active===false && resJSON.data[i].bp[j].is_verified===true){
                        stat="BP Terealisasi";
                    }
                    status[count]=stat;
                    count=count+1;
                }
                total1[i]=total2;
                semua_data[i]=tam1;
            }

            var urutan=[]; var tambah=0; var tambah1=0;
            for(var i=0; i<semuaBP.length; i++){
                if(i>=1){
                    if(semuaSTS[i]!==semuaSTS[i-1]){
                        tambah=tambah+1;
                    }
                } else { urutan[i]=tambah; }
                if(tambah1!==tambah){
                    urutan[i]=tambah;
                    tambah1=tambah;
                }
               
            }
            this.setState({
                data: semuaBP,
                total: total1,
                urutan: urutan,
                status: status,
                semua_data: semua_data,
                semuaSTS: semuaSTS,
                rowSpan: rowSpan,
                requests: false,
                totalPages: 4,
            })
        })
        .catch(e => {
            this.setState({
                requests:false,
            })
            window.alert("Server gangguan")
        })
    }

    searchSts(e) {
        this.setState({q: e.target.value})      
        const { startDate, endDate } = this.state
        const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
        const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD')

        fetch(`${BaseURLDev}/sts?q=${e.target.value}&start=${start_date}&end=${end_date}`, { headers })
        .then(response => {
            if(!response.ok){
                window.alert("Load data gagal")               
                this.setState({data:[],requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => (
            this.setState({data:resJSON.data,totalPages:resJSON.totalPage,requests:false})
        ))
    }

    exportData(){
        printJS({
            printable: 'print_data',
            type: 'html',
            modalMessage:"Sedang memuat data...",
            showModal:true,
            maxWidth:'1300',
            font_size:'8pt',
            documentTitle:'Rincian BP',
            targetStyle: [
                'margin',
                'color',
                'border-collapse',
                'border-spacing',
                'border-style',
                'border-style',
                'margin-bottom',
                'padding',
                'Label',
                'background'
            ]
        })
    }

    render() {
        const { data, total, rowSpan , semua_data, activePage , totalPages, semuaSTS, urutan, status} = this.state;
        const styletb = {
            borderCollapse:'collapse',
            borderSpacing:0,
            borderStyle:'solid',
            width:'100%',
            fontSize:'12px',
            paddingTop:'20px'
        }
        return (
            <div>
                <div>       
                <Message
                        error
                        header='** Penting!'
                        content='Silahkan memilih Rentang Tanggal terlebih dahulu sebelum menekan tombol Filter'
                    />               
                    <Menu>
                        <Menu.Item>
                            <DateRangePicker
                            hideKeyboardShortcutsPanel
                            reopenPickerOnClearDates
                            showClearDates
                            minimumNights={0}
                            withPortal
                            showDefaultInputIcon
                            displayFormat="DD/MM/YYYY"
                            small={true}                              
                            numberOfMonths={2}
                            startDatePlaceholderText="Awal"
                            endDatePlaceholderText="Akhir"
                            startDateId="startDateId"
                            endDateId="endDateId"
                            isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                            />
                        </Menu.Item>
                        <Menu.Item>                     
                            <Button.Group size='small'>
                            <Button content="Filter" disabled={this.state.startDate===null && this.state.endDate===null} color='green' icon='filter' onClick={this.onFilter}/>
                            <Button color='blue' disabled={this.state.requests} content="Refresh" icon='refresh' onClick={this.onRefresh} />                        
                            </Button.Group>
                        </Menu.Item>
                        <Menu.Item position="right">
                            <Button color='blue' size="small" onClick={()=>this.exportData()}> 
                                <p><Icon name='print' className='left floated' />Preview</p>
                            </Button> 
                        </Menu.Item>
                    </Menu>
                    <div ref={el => (this.componentRef = el)} id="print_data">
                    <style type="text/css">
                        {"@media print{@page {size: 8.5in 14in; margin: 40px; }}"}
                    </style>
                    <Segment>
                        {(this.state.loading_detail || this.state.requests) ?
                            <Loader active inline='centered' size='medium'>Loading...</Loader>
                        :
                        <div>
                            <table border="1" align="center" style={styletb} width="100%">
                                <tbody>            
                                    <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                        <th rowSpan="2" width="4%" style={{padding:'4px',textAlign:"center"}}>No.</th>
                                        <th rowSpan="2" width="6%"style={{padding:'4px',textAlign:"center"}}>Status</th>
                                        <th colSpan="2" width="20%" style={{padding:'4px',textAlign:"center"}}>Nomor</th>
                                        <th colSpan="2" style={{padding:'4px',textAlign:"center"}}>Tanggal</th>
                                        <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Keterangan</th>
                                        <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Rincian</th>
                                        <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Total</th>
                                    </tr>
                                    <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                        <th style={{padding:'4px',textAlign:"center"}}>BP</th>
                                        <th style={{padding:'4px',textAlign:"center"}}>STS</th>
                                        <th style={{padding:'4px',textAlign:"center"}}>Pembuatan</th>
                                        <th style={{padding:'4px',textAlign:"center"}}>Realisasi</th>
                                    </tr>
                                    {data.length === 0 && 
                                        <tr>
                                            <th colSpan="9">Data tidak ditemukan</th>                           
                                        </tr>
                                    } 
                                    {
                                    
                                    data.map((item,i) => (
                                    <tr key={i}> 
                                        {
                                            (semuaSTS[i] === semuaSTS[i-1]) ? null :
                                            <td style={{padding:'4px',textAlign:"center"}} rowSpan={rowSpan[urutan[i]]}>{urutan[i]+1+(activePage-1)*10}.</td>
                                        } 
                                        <td style={{padding:'4px',textAlign:"center"}}>
                                        {
                                            (status[i]==="BP Non STS")?
                                            <Label color='red' horizontal>BP Non STS</Label> :
                                            (status[i]==="BP STS")?
                                            <Label color='yellow' horizontal>BP STS</Label> :
                                            (status[i]==="BP Terealisasi")?
                                            <Label color='blue' horizontal>BP Terealisasi</Label> : null
                                        }
                                        </td>                                                
                                        <td style={{padding:'4px',textAlign:"center"}}>{item.no_bukti}</td>
                                        {
                                            (semuaSTS[i] === semuaSTS[i-1]) ? null : <td style={{padding:'4px',textAlign:"center"}} rowSpan={rowSpan[urutan[i]]}>{semuaSTS[i]}</td>
                                        }
                                        
                                        <td style={{padding:'4px',textAlign:"center"}}>{toDMYDate(item.created_at)}</td>
                                        <td style={{padding:'4px',textAlign:"center"}}>{toDMYDate(item.tgl_realisasi)}</td>
                                        <td style={{padding:'4px'}}>{item.uraian}</td>
                                        {
                                            (semuaSTS[i] === semuaSTS[i-1]) ? null : 
                                            <td style={{padding:'4px'}} rowSpan={rowSpan[urutan[i]]}>
                                            {
                                                semua_data[urutan[i]]
                                            }
                                            </td>
                                        }
                                        {
                                            (semuaSTS[i] === semuaSTS[i-1]) ? null : 
                                            <td style={{padding:'4px',textAlign:"right"}} rowSpan={rowSpan[urutan[i]]}>
                                            {
                                                toIDR(total[urutan[i]])
                                            }
                                            </td>
                                        }
                                    </tr>
                                    ))
                                    }
                                </tbody>        
                            </table>
                            <br/>
                            <Pagination activePage={activePage} 
                                onPageChange={this.handlePaginationChange} 
                                totalPages={totalPages}
                            />
                            <br/><br/><br/>
                            <table border="1" align="center" style={styletb} width="100%">
                                <tr style={{background:'#e5e5e5'}}>
                                    <th style={{padding:'4px', width:'80%'}} align="right">Jumlah</th>
                                    <th style={{padding:'4px'}} align="right">
                                    </th>
                                </tr>
                            </table>
                            </div>
                        }
                    </Segment>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_report/RegisterSTS.js